import React, { FC, useRef, useState } from 'react'
import { Icon } from '@wmgtech/legato'

import { TList } from './types'
import styles from './collapse.module.scss'

export interface ICollapseProps {
  list: Array<TList>
  className?: string
}

const CollapseItem: FC<TList> = ({title, content, expand})  => {
  const [expanded, setExpanded] = useState(expand)
  const contentHeight = useRef<any>()
  const handleItemClick = () => {
    setExpanded(!expanded)
  }

  return(
    <div className={styles['collapse-wrapper']}>
      <div className={styles['collapse-header']} onClick={handleItemClick} >
        <h4>{title}</h4>
        <Icon name="angle-down" className={`${styles.arrow} ${expanded ? styles.active : ''}`} /> 
      </div>
 
      <div ref={contentHeight} className={styles['collapse-content']} style={
        expanded
          ? { height: contentHeight?.current?.scrollHeight }
          : { height: '0px' }
      }>
        <p>{content}</p>
      </div>
    </div>
  )
}

export const Collapse: FC<ICollapseProps> = ({ list, className }) => {
  return (
    <>
      {list.map((item, index) => ( 
        <CollapseItem
          key={index}
          id={index}
          title={item.title}
          content={item.content}
          expand={item.expand}
        />
      ))}
    </>
  )
}

export default Collapse
